'use strict';

import { Entity } from '../Entity';

export class IndDrug2 extends Entity {
  protected indDrugId;

  protected indId;

  protected indDrugName;

  protected indDrugRxcui;

  protected indDrugFullName;

  protected indDrugHiRxcui;

  protected indDrugPackage;

  protected indDrugNdc;

  protected indDrugQuantity;

  protected indDrugFrequency;

  protected indDrugFormulary;

  protected indDrugNote;

  protected indDrugStatus = 'Active';

  protected indDrugQuotable;

  protected indDrugNdcAll = [];

  protected dateTimeCreated;

  protected dateTimeUpdated;

  protected archived;

  protected dateTimeArchived;

  constructor() {
    super();
  }

  public hydrate(data: any) {
    this.indDrugId = data.indDrugId;

    this.indId = data.indId;

    this.indDrugName = data.indDrugName;

    this.indDrugRxcui = data.indDrugRxcui;

    this.indDrugFullName = data.indDrugFullName;

    this.indDrugHiRxcui = data.indDrugHiRxcui;

    this.indDrugPackage = data.indDrugPackage;

    this.indDrugNdc = data.indDrugNdc;

    this.indDrugQuantity = data.indDrugQuantity;

    this.indDrugFrequency = data.indDrugFrequency;

    this.indDrugFormulary = data.indDrugFormulary;

    this.indDrugNote = data.indDrugNote;

    this.indDrugStatus = data.indDrugStatus;

    this.indDrugQuotable = data.indDrugQuotable;

    this.indDrugNdcAll = data.indDrugNdcAll;

    this.archived = data.archived;

    if (data.dateTimeCreated) {
      const dateTimeCreated = data.dateTimeCreated.date.split(' ')[0].split('-');
      this.dateTimeCreated =
        dateTimeCreated[1] + '/' + dateTimeCreated[2] + '/' + dateTimeCreated[0];
    }

    if (data.dateTimeUpdated) {
      const dateTimeUpdated = data.dateTimeUpdated.date.split(' ')[0].split('-');
      this.dateTimeUpdated =
        dateTimeUpdated[1] + '/' + dateTimeUpdated[2] + '/' + dateTimeUpdated[0];
    }

    if (data.dateTimeArchived) {
      const dateTimeArchived = data.dateTimeArchived.date.split(' ')[0].split('-');
      this.dateTimeArchived =
        dateTimeArchived[1] + '/' + dateTimeArchived[2] + '/' + dateTimeArchived[0];
    }
  }

  public getIndDrugId() {
    return this.indDrugId;
  }

  public getIndId() {
    return this.indId;
  }

  public getIndDrugName() {
    return this.indDrugName;
  }

  public getIndDrugRxcui() {
    return this.indDrugRxcui;
  }

  public getIndDrugFullName() {
    return this.indDrugFullName;
  }

  public getIndDrugHiRxcui() {
    return this.indDrugHiRxcui;
  }

  public getIndDrugPackage() {
    return this.indDrugPackage;
  }

  public getIndDrugNdc() {
    return this.indDrugNdc;
  }

  public getIndDrugQuantity() {
    return this.indDrugQuantity;
  }

  public getIndDrugFrequency() {
    return this.indDrugFrequency;
  }

  public getIndDrugFormulary() {
    return this.indDrugFormulary;
  }

  public getIndDrugNote() {
    return this.indDrugNote;
  }

  public getIndDrugStatus() {
    return this.indDrugStatus;
  }

  public getIndDrugQuotable() {
    return this.indDrugQuotable;
  }

  public getIndDrugNdcAll() {
    return this.indDrugNdcAll;
  }

  public getDateTimeCreated() {
    return this.dateTimeCreated;
  }

  public getDateTimeUpdated() {
    return this.dateTimeUpdated;
  }

  public isArchived() {
    return this.archived;
  }

  public getDateTimeArchived() {
    return this.dateTimeArchived;
  }
}
